































import { Component, Vue } from 'vue-property-decorator';
import createLeagueServices from '../../services/CreateLeagueService';

@Component({
    components: {
    },
})
export default class CreateLeagueStep1 extends Vue {
    private competitions = [];
    private selectedCompetition = '0';
    private title = '';
    async mounted() {
        this.competitions = await createLeagueServices.fetchCompetitions()
        }
    private selectCompetition(id: string) {
        this.selectedCompetition = id;
        this.update();
    }

    private update() {
        this.$emit("updateLeague", [
            {
                key: "title",
                value: this.title
            },
            {
                key: "competition",
                value: this.selectedCompetition
            }
        ])
    }

}
